import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=5d05837c&scoped=true"
import script from "./AlertCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=5d05837c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05837c",
  null
  
)

export default component.exports